export class Empresa {
  id_empresa: number;
  nome_fantasia: string;
  cnpj: string;
  razao_social: string;
  telefone: string;
  cidade: string;
  estado: string;
  endereco: string;
  bairro: string;
  complemento: string;
  cep: string;
  numero: string;
  url: string;
  id_usuarios: number;
  data_cadastro: Date;
  usuario: Usuario;
  id_segmento: number;
  latitude: string;
  longitude: string;
  constructor() {
    this.usuario = new Usuario();
  }
}

export class Usuario {
  id_usuarios: number;
  nome: string = "";
  email: string = "";
  senha: string = "";
  repetirSenha: string = "";
}
